<!-- @format -->

<sis-study-substitution-box
  [substituteCourseUnits]="substituteCourseUnits"
  [level]="headingLevel"
  [showCompletionMethodSelection]="true"
  [courseUnitsById]="planData?.courseUnitsById"
  (nameClickAction)="openCourseUnitInfoModal($event)">
</sis-study-substitution-box>
